import { useMonitor } from '../use-monitor';

export function useMonitorManageIssueFormLoad() {
  return useMonitor('manage-issue-form-load');
}
